import { importTypes } from './importTypes';

const companyAccountsTemplateHeaders = ['Лицевой счет', 'Адрес', 'Баланс'];

export const templates = {
  [importTypes.owners]: {
    name: 'Шаблон (собственники).xlsx',
    url: 'Request/get_template_owners',
    errMsg: 'Не удалось получить шаблон для импорта собственников',
  },

  [importTypes.personalAccounts]: {
    name: 'Шаблон (лицевые счета).xlsx',
    url: 'Request/templates/accounts',
    errMsg: 'Не удалось получить шаблон для импорта лицевых счетов',
  },

  [importTypes.personalAccountsByCompanies]: {
    name: 'Шаблон (лицевые счета по УК).xlsx',
    headers: companyAccountsTemplateHeaders,
  },

  [importTypes.individualMeters]: {
    name: 'Шаблон (ИПУ).xlsx',
    url: 'Meter/mass_load_template',
    errMsg: 'Не удалось получить шаблон для импорта ИПУ',
  },
};
